import React from 'react';
import { FiCalendar } from 'react-icons/fi';

/**
 * Conmutador mensual / anual (misma UX que /planes).
 */
export default function PlanBillingCycleToggle({
  billingCycle = 'monthly',
  onChange,
  modoOscuro = false,
  textMuted = 'text-gray-500',
  className = '',
  hint,
}) {
  const cycle = billingCycle === 'annual' ? 'annual' : 'monthly';

  return (
    <div className={`flex flex-col items-center gap-1.5 ${className}`.trim()}>
      <div
        className={`flex items-center justify-center gap-2 p-1 rounded-full ${
          modoOscuro ? 'bg-gray-800/70' : 'bg-gray-100'
        }`}
      >
        <button
          type="button"
          onClick={() => onChange?.('monthly')}
          className={`px-3 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium transition-all ${
            cycle === 'monthly'
              ? modoOscuro
                ? 'bg-gray-700 text-white shadow-md'
                : 'bg-white text-gray-900 shadow-md'
              : modoOscuro
                ? 'text-gray-400 hover:text-white'
                : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          Mensual
        </button>
        <button
          type="button"
          onClick={() => onChange?.('annual')}
          className={`px-3 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium transition-all flex items-center gap-1.5 ${
            cycle === 'annual'
              ? modoOscuro
                ? 'bg-green-600 text-white shadow-md'
                : 'bg-green-500 text-white shadow-md'
              : modoOscuro
                ? 'text-gray-400 hover:text-white'
                : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <FiCalendar className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
          Anual
          <span
            className={`text-[10px] sm:text-xs px-1.5 py-0.5 rounded-full ${
              cycle === 'annual'
                ? 'bg-white/20'
                : modoOscuro
                  ? 'bg-green-900/50 text-green-300'
                  : 'bg-green-100 text-green-600'
            }`}
          >
            -17%
          </span>
        </button>
      </div>
      <p className={`text-[11px] sm:text-xs text-center ${textMuted}`}>
        {hint
          || (cycle === 'annual'
            ? 'Ahorrá 2 meses pagando anualmente'
            : 'Podés elegir facturación anual para cuando termine la beta')}
      </p>
    </div>
  );
}
